import styled, { css } from "styled-components";
import { Flex, Constants } from "@nubeteck/components";

const { maxDevice } = Constants;

export const PaymentMethodsGridStyled = styled(Flex)`
  gap: 16px;
  width: 100%;
  margin: 10px 0 20px;

  @media ${maxDevice.mobileL} {
    flex-direction: column;
  }
`;

export const PaymentMethodCardStyled = styled.button<{ $disabled?: boolean }>`
  flex: 1 1 220px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px 16px;
  border-radius: 20px;
  border: 2px solid ${({ theme }) => theme.colors.colorLightGray};
  background: #fff;
  cursor: pointer;
  text-align: center;
  font-family: inherit;
  filter: drop-shadow(0px 4px 15px rgba(0, 0, 0, 0.05));
  transition:
    border-color 0.2s ease,
    transform 0.15s ease,
    filter 0.2s ease;

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.primary500};
    transform: translateY(-3px);
    filter: drop-shadow(0px 6px 18px rgba(0, 106, 234, 0.18));
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  ${({ $disabled }) =>
    $disabled &&
    css`
      opacity: 0.5;
      cursor: not-allowed;
      transform: none;
    `}
`;

export const PaymentMethodIconWrapperStyled = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme }) => theme.colors.primary100};
  color: ${({ theme }) => theme.colors.primary500};
  font-size: 28px;
`;

export const PaymentMethodTitleStyled = styled.span`
  font-weight: 700;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.colorTextHeading};
`;

export const PaymentMethodDescriptionStyled = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.colorGray};
`;

export const ChangeCurrencyButtonStyled = styled.button`
  border: none;
  background: none;
  padding: 0 0 8px;
  margin: 0;
  color: ${({ theme }) => theme.colors.primary500};
  font-weight: 600;
  font-size: 13px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 4px;

  &:hover {
    text-decoration: underline;
  }
`;
